module.exports = __webpack_public_path__ + "static/how-it-works-step2-595d532ea3ecbb97474b568b8c8c65e3.svg";